module.exports = __webpack_public_path__ + "static/img/empty.516b6ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/empty.png
// module id = fYQv
// module chunks = 1